module.exports = __webpack_public_path__ + "img/cards.cc459ff0.png";